import filterObject from '@/utils/filter-object'

export default {
  data() {
    return {
      filters: {},
    }
  },
  async mounted() {
    if (this.$route.query.filters) this.filters = JSON.parse(atob(this.$route.query.filters))
  },
  computed: {
    filtersActivated() {
      return !!this.$route.query.filters
    },
  },
  watch: {
    filters: {
      deep: true,
      async handler() {
        if (!this.loading) await this.getResources()
        const query = JSON.parse(JSON.stringify(this.$route.query))
        const filters = filterObject(this.filters)
        if (Object.keys(filters).length > 0) query.filters = btoa(JSON.stringify(filters))
        if (Object.keys(filters).length === 0) delete query.filters
        this.$router.replace({ query }).catch(() => {})
      },
    },
  },
  methods: {
    resetFilters() {
      this.filters = {}
    },
  },
}
